/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: Index
 * Page name: Home page
 * Page Description: This is the home page of the website of Ekathva Innovations, it consists of all the
 * brief details about the company and its business.
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, HashRouter, Route, Switch, Redirect } from "react-router-dom";



// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.4.0";
import "assets/demo/demo.css?v=1.4.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.4.0";

// pages for this kit
import Index from "views/Index.js";

import AboutUsPage from "views/AboutUsPage"
import ProductsPage from "views/ProductsPage"
import Technologies from "views/Technologies"
import ContactUsPage from "views/ContactUsPage"
import ItServicePage from "views/ItServicePage"
import EmbeddedServicePage  from "views/EmbeddedServicePage"
import SuccessStoriesPage from "views/SuccessStoriesPage"
import Sitemap from "views/sitemap"
import TestimonialsPage from "views/TestimonialsPage"

import CareerPage from "views/CareerPage"
import MediaPage from "views/MediaPage"
import TrainingPage from "views/TrainingPage"
import OurClientsPage from "views/OurClientsPage"
import PrivacyPolicyPage from "views/PrivacyPolicy";


import SimpleReactLightbox from 'simple-react-lightbox'


ReactDOM.render(

  <BrowserRouter basename="">
  <SimpleReactLightbox>
    <Switch>
      <Switch>

      <Route path="/index" render={(props) => <Index {...props} />} />
        <Route
          path="/Index"
          render={(props) => <Index {...props} />}
        />
        <Route
          path="/about-us"
          render={(props) => <AboutUsPage {...props} />}
        />
        <Route
          path="/products"
          render={(props) => <ProductsPage {...props} />}
        />

        <Route
          path="/technologies"
          render={(props) => <Technologies {...props} />}
        />
        <Route
          path="/success-story"
          render={(props) => <SuccessStoriesPage{...props} />}
        />

        <Route
          path="/contact-us"
          render={(props) => <ContactUsPage {...props} />}
        />
        <Route
          path="/sitemap"
          render={(props) => <Sitemap {...props} />}
        />
        <Route
          path="/our-clients"
          render={(props) => <OurClientsPage {...props} />}
        />
        <Route
          path="/training"
          render={(props) => <TrainingPage {...props} />}
        />
        <Route
          path="/testimonials"
          render={(props) => <TestimonialsPage {...props} />}
        />
        <Route
          path="/media-gallery"
          render={(props) => <MediaPage {...props} />}
        />
        <Route
          path="/career"
          render={(props) => <CareerPage {...props} />}
        />
        <Route
          path="/it-services"
          render={(props) => <ItServicePage {...props} />}
        />
        <Route
          path="/embedded-services"
          render={(props) => <EmbeddedServicePage {...props} />}
        />
         <Route
          path="/privacy-policy"
          render={(props) => <PrivacyPolicyPage {...props} />}
        />

        <Redirect to="/index" />
        <Redirect from="/" to="/index" />

      </Switch>
    </Switch>
    </SimpleReactLightbox>
  </BrowserRouter>,
  document.getElementById("root")
);
